import {
  AnyObject,
  BaseQuery,
  defaultEmailValidation,
  isValidDate,
  isValidPhoneNumber,
  removeArrayContainsFilter,
} from '@hb/shared'

const toPatientColonCommandQuery = <T extends AnyObject>(
  colonCommand: string,
): BaseQuery<T> | null => {
  switch (colonCommand.toLowerCase()) {
    case 'deep':
      return null
    default:
      break
  }
  return null
}

export const toPatientSearchQuery = <T extends AnyObject>(
  baseQuery: BaseQuery<T>,
  search: string,
): BaseQuery<T> | null => {
  const [colonCommand, colonParam] = search.split(':')
  if (colonCommand && colonParam) return toPatientColonCommandQuery(colonCommand)
  if (!defaultEmailValidation(search)) {
    return {
      ...baseQuery,
      filters: [...(baseQuery.filters || []), ['emailLower', '==', search.toLowerCase()]],
    }
  }

  const isPhoneNumber = isValidPhoneNumber(search)
  if (isPhoneNumber) {
    const parsedPhoneNumber = search.replace(/\D/g, '')
    return {
      ...baseQuery,
      filters: [...(baseQuery.filters || []), ['phone', '==', parsedPhoneNumber]],
    }
  }
  // check if search is a date (DOB)
  if (isValidDate(search)) {
    return {
      ...baseQuery,
      filters: [...(baseQuery.filters || []), ['dobString', '==', search]],
    }
  }

  const trimmed = search.toLowerCase().trim()
  // default to name search
  return {
    ...baseQuery,
    filters: [
      ...removeArrayContainsFilter(baseQuery.filters),
      ['names', 'array-contains', trimmed],
    ],
  }
}
